interface V3IconWebProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconWeb = ({ stroke = "#ABB0BA", ...rest }: V3IconWebProps) => <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 6h14M1 10h14" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M8 1C6.04 3.1 5 5.525 5 8c0 2.475 1.04 4.9 3 7M8 1c1.96 2.1 3 4.525 3 7 0 2.475-1.04 4.9-3 7" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>